import type { ICellRendererParams } from 'ag-grid-enterprise';
import { Side } from '../../Side';
import { baseColumn } from './baseColumn';
import { messages as columnHeaderTranslations } from './columnHeaderTranslations';
import type { ColDefFactory, Column } from './types';

export const side: ColDefFactory<Column> = column => ({
  initialWidth: 60,
  ...baseColumn(column),
  cellRenderer: (params: ICellRendererParams) => {
    const displayValue = params.context.current.intl.formatCell(params, columnHeaderTranslations);
    return (
      <Side theme={params.context.current.theme} side={params.value}>
        {displayValue}
      </Side>
    );
  },
});
